import React, { Component } from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';

import { CSSTransitionGroup } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavHashLink as NavLink, HashLink as Link } from 'react-router-hash-link';

import { Account, APIHandler, DataHandler, Dropdown, SideMenu, StorageHandler, BackButton, PopUpSearch } from 'C4';

import { storageKeys, name } from 'settings';

import logo from 'assets/images/logo/logo.png';
import logoFR from 'assets/images/logo/logo-fr.png';

const navButtons = {
  favorites: 'heart',
  // search: 'search',
};

const resetScrollPosition = () => window.scrollTo(0, 0);

const NavButton = ({ loggedIn, icon, route }) => (
  <li className={clsx({ disabled: loggedIn })}>
    <NavLink onClick={resetScrollPosition} activeClassName="is-active" to={`${route}`} className={icon}>
      {icon === 'heart' && (
        <FontAwesomeIcon
          icon={[typeof icon === 'string' ? 'far' : icon[0], typeof icon === 'string' ? icon : icon[1]]}
        />
      )}
      {icon !== 'heart' && (
        <FontAwesomeIcon
          icon={[typeof icon === 'string' ? 'fas' : icon[0], typeof icon === 'string' ? icon : icon[1]]}
        />
      )}
    </NavLink>
  </li>
);

class Nav extends Component {
  constructor(props) {
    super(props);

    this.handleScroll = this.handleScroll.bind(this);
    this.state = {
      loggedIn: false,
      firstName: 'Login',
      lastName: '',
      menuToggle: false,
      accountToggle: false,
      lastCheckedMessages: '',
      unreadMessageCount: '',
      show: true,
      language: 'en',
      buttonPopup: false,
    };

    this.handleMenuToggle = this.handleMenuToggle.bind(this);
    this.handleAccountToggle = this.handleAccountToggle.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentWillMount() {
    StorageHandler.load(storageKeys.lastCheckedMessage).then((res) => {
      if (res) {
        this.setState({ lastCheckedMessages: res });
      }
      this.checkForUnreadMessages();
    });

    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        this.setState({
          loggedIn: true,
          firstName: res.first_name,
          lastName: res.last_name,
          email: res.email,
        });
        DataHandler.requestWithId(APIHandler.getUserProgress, res.email).then((progress) => {
          const { chapters } = progress.data[0];
          this.setState({ trainingComplete: chapters.every((chapter) => chapter.progress >= chapter.total_pages) });
        });
      } else {
        this.setState({ loggedIn: res });
      }
    });
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.setLanguage();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  checkForUnreadMessages() {
    DataHandler.requestWithId(APIHandler.getUnreadMessages, this.state.lastCheckedMessages).then((res) => {
      this.setState({ unreadMessageCount: res.missed_items[0].count });
    });
  }

  setLanguage() {
    StorageHandler.load(storageKeys.lang).then((lang) => {
      this.setState({ language: lang.langFile });
    });
  }

  handleMenuToggle() {
    const container = document.getElementById('container');
    this.setState((prevState) => ({
      menuToggle: !prevState.menuToggle,
    }));
    container.classList.remove('offsetContainer');
    window.scrollTo(0, 0);
  }

  handleAccountToggle() {
    this.setState((prevState) => ({
      accountToggle: !prevState.accountToggle,
    }));
    this.checkForUnreadMessages();
  }

  handleClickOutside() {
    const container = document.getElementById('container');
    this.setState({ menuToggle: false, accountToggle: false });
    container.classList.remove('offsetContainer');
  }

  handleScroll() {
    if (window.scrollY < 15) this.setState({ show: true });
    else this.setState({ show: false });
  }
  handlePopup = (e) => {
    // e.stopPropagation();
    this.setState((prevState) => ({
      buttonPopup: !prevState.buttonPopup,
    }));
  };

  render() {
    const {
      accountToggle,
      email,
      firstName,
      lastName,
      loggedIn,
      menuToggle,
      trainingComplete,
      unreadMessageCount,
      show,
      language,
      buttonPopup,
    } = this.state;
    const { pathname, hasBackButton } = this.props;

    return (
      <div>
        <nav className="mini">
          <div className="container__backButton">{hasBackButton && <BackButton useHistory={false} text="Back" />}</div>
          <Link to="/main" className="logo">
            {pathname !== '/main' && pathname !== '/' && pathname !== '/main/' && (
              <React.Fragment>
                {show && language !== 'fr' && <img src={`/${logo}`} alt="logo" id="logoHeader" />}
                {show && language === 'fr' && <img src={`/${logoFR}`} alt="logo" id="logoHeader" />}
              </React.Fragment>
            )}
          </Link>
          <ul className="secondaryNav">
            {/* TODO change this map, it isn't neened */}
            {Object.keys(navButtons).map((key) => (
              <NavButton key={key} icon={navButtons[key]} route={`/main/${key}`} loggedIn={loggedIn} />
            ))}
            {/* style this with search icon */}
            <button className="searchButton" onClick={this.handlePopup}>
              {this.state.buttonPopup ? 'Close Popup' : 'Open Popup'}
            </button>
            <li className={loggedIn ? ' ' : 'navLogin'}>
              {loggedIn ? (
                <Account onClick={this.handleAccountToggle} firstName={firstName} expanded={accountToggle} />
              ) : (
                <NavLink exact to="/login">
                  <button className="account">
                    <FontAwesomeIcon icon={['fas', 'user']} />
                    {firstName}
                  </button>
                </NavLink>
              )}
            </li>
          </ul>
        </nav>

        <CSSTransitionGroup transitionName="accountToggle" transitionEnterTimeout={150} transitionLeaveTimeout={150}>
          {accountToggle && (
            <Dropdown
              handleClickOutside={this.handleClickOutside}
              outsideClickIgnoreClass="account"
              firstName={firstName}
              lastName={lastName}
              email={email}
              unreadMessageCount={unreadMessageCount}
              openSettings={this.openSettings}
              trainingComplete={trainingComplete}
              diploma={(src) => this.frame(src)}
            />
          )}
        </CSSTransitionGroup>
        <CSSTransitionGroup transitionName="menuToggle" transitionEnterTimeout={250} transitionLeaveTimeout={250}>
          {menuToggle && (
            <SideMenu
              handleClickOutside={this.handleClickOutside}
              outsideClickIgnoreClass="burgerMenu"
              firstName={firstName}
              lastName={lastName}
              email={email}
            />
          )}
        </CSSTransitionGroup>
        <PopUpSearch buttonPopup={this.state.buttonPopup} handlePopup={this.handlePopup}></PopUpSearch>
      </div>
    );
  }
}

export default Nav;

Nav.propTypes = {
  pathname: PropTypes.string,
  hasBackButton: PropTypes.bool,
};

Nav.defaultProps = {
  pathname: '',
  hasBackButton: true,
};

NavButton.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  route: PropTypes.string.isRequired,
};

NavButton.defaultProps = {
  icon: ['fas', 'stroopwafel'],
};
